
/**
 * Executes the given callback whenever a user signs in or out.
 * This can be used to update the UI accordingly
 * @return {function} Cancels the signin event handling. It should be used for cleanup.
 */
export const onSignInOutExecute = function (callbackName) {
    const callback = typeof callbackName === 'function'
        ? callbackName
        : window[callbackName];

    $(window).on('signinTriggered signoutTriggered', callback);

    return () => $(window).off('signinTriggered signoutTriggered', callback);
};
